const generateBackgroundColor = (omit = '') => {
    let colors = ['primary', 'secondary', 'success', 'info', 'warning', 'danger'];

    colors = TB.reject(colors, omit);

    return TB.first(TB.shuffle(colors))
}


import React, {useMemo} from 'react';
import PropTypes from 'prop-types';


const UserImageCircle = ({className = '', size = 30, user = {}, ...props}) => {

    const COLORS = {
        // [TB.config('color.primary')]: 'white',
        // [TB.config('color.secondary')]: 'white',
        // [TB.config('color.success')]: 'black',
        // [TB.config('color.info')]: 'white',
        // [TB.config('color.warning')]: 'black',
        // [TB.config('color.danger')]: 'white',
        // [TB.config('color.primary-light')]: 'white',
        // [TB.config('color.secondary-light')]: 'white',
        [TB.config('color.success-light')]: 'black',
        [TB.config('color.info-light')]: 'white',
        [TB.config('color.warning-light')]: 'black',
        [TB.config('color.danger-light')]: 'white',
        // [TB.config('color.primary-lighter')]: 'white',
        [TB.config('color.secondary-lighter')]: 'white',
        [TB.config('color.success-lighter')]: 'black',
        [TB.config('color.info-lighter')]: 'white',
        [TB.config('color.warning-lighter')]: 'black',
        [TB.config('color.danger-lighter')]: 'white',
        // [TB.config('color.primary-lightest')]: 'white',
        // [TB.config('color.secondary-lightest')]: 'white',
        // [TB.config('color.success-lightest')]: 'black',
        // [TB.config('color.info-lightest')]: 'white',
        // [TB.config('color.warning-lightest')]: 'black',
        // [TB.config('color.danger-lightest')]: 'white',
        // [TB.config('color.primary-dark')]: 'white',
        // [TB.config('color.secondary-dark')]: 'white',
        // [TB.config('color.success-dark')]: 'black',
        // [TB.config('color.info-dark')]: 'white',
        // [TB.config('color.warning-dark')]: 'black',
        // [TB.config('color.danger-dark')]: 'white',
        '#ADB1B5': 'white', // gray
    }
    const getInitials = (data) => {
        if (data != null) {
            let chr;
            const d = data.toUpperCase();
            chr = d.split(" ");
            if (chr.length >= 2) {
                return chr[0][0] + chr[1][0];
            } else {
                return d[0] + d[1];
            }
        }
        return "";
    }
    const getColorForInitial = (letter = "") => {
        if(!letter?.length) return Object.keys(COLORS)[1];
        if(className.includes('img-grayscale')) return Object.keys(COLORS)[Object.keys(COLORS).length - 1];
        let code = letter.toUpperCase().charCodeAt(0);

        if (code > 64 && code < 91) {
            code -= 64;
            let activeColors = [
                ...Object.keys(COLORS),
                ...Object.keys(COLORS),
                ...Object.keys(COLORS)
            ]
            let randomIndex = Math.floor((code / 26) * activeColors.length);
            return activeColors[randomIndex];
        }
    }

    const isMissingImage = useMemo(() => {
        return !user?.image_path || String(user.image_path).includes('default-user')
    }, [user.image_path]);

    const bgColor = useMemo(() => {
        return getColorForInitial(TB.first(user.label || user?.first_name || user.last_name))
    }, [user?.first_name, user.label]);

    const circleBgStyle = useMemo(() => {

        if (!isMissingImage && !props.initialsOnly) {
            return {backgroundImage: `url('${user.image_path}')`}
        }

        if (String(user.label || user?.first_name || user.last_name).length > 0) {
            return {backgroundColor: bgColor, filter: 'none'}
        }

        return {}
    }, [user?.image_path]);

    if (!user) return null;

    let {
        hideTooltip,
        initialsOnly,
        ...tooltipProps
    } = {...(props || {})}
    return (
        <div data-toggle={hideTooltip ? undefined : "tooltip"}
             data-placement="top"
             title={user && user.firstNamePlusInitial?.()}
             className={"user-image-circle " + className}
             style={{minWidth: size,width: size, minHeight: size, height: size, ...circleBgStyle}}
             {...tooltipProps}>
            {(initialsOnly || isMissingImage) && (
                <div className="initials" style={{color: COLORS[bgColor], fontSize: `calc(${parseInt(size) ? `${size}px` : size} / 3)`}}>
                    {getInitials(user?.label || user?.fullName?.())}
                </div>
            )}
        </div>
    )
}

UserImageCircle.propTypes = {
    user: PropTypes.any,
    size: PropTypes.any,
    className: PropTypes.any,
    initialsOnly: PropTypes.any,
};

export default UserImageCircle;